import appLogger from '@shared/logging/appLogger';
import React, { Component, ErrorInfo, ReactNode } from 'react';

import styles from './ErrorBoundary.module.scss';
import InternalError from './InternalError';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fallback?: any;
    onError?: () => void;
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const defaultState: State = {
            hasError: false,
            error: undefined,
        };
        this.state = defaultState;
    }

    state: State = {
        hasError: false,
    };
    props: Props;

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error: error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        let additionalProperties: Record<string, string>;

        if (errorInfo?.componentStack) {
            additionalProperties = {
                componentStack: errorInfo.componentStack,
            };
        }
        appLogger.logException({ error: error, properties: additionalProperties });
    }

    render() {
        const props = this.props;
        const state = this.state;
        if (state.hasError) {
            props?.onError && props.onError();
            return React.isValidElement(props.fallback) ? (
                props.fallback
            ) : (
                <div className={styles['error-boundary-margin-top']}>
                    <InternalError />
                </div>
            );
        }

        return props.children;
    }
}

export default ErrorBoundary;
